export default __webpack_public_path__ + "static/media/china.b473bcf2.png";